import script from "./ChapterFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ChapterFilters.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__